import styled from '@emotion/styled/macro';

export const PlaceholderContent = styled.section`
    padding: 24px;
`;
